var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "left-board" },
      [
        _c("el-scrollbar", { staticClass: "left-scrollbar" }, [
          _c(
            "div",
            { staticClass: "components-list" },
            [
              _c(
                "draggable",
                {
                  staticClass: "components-draggable",
                  attrs: {
                    list: _vm.componentList,
                    group: {
                      name: "componentsGroup",
                      pull: "clone",
                      put: false
                    },
                    clone: _vm.cloneComponent,
                    draggable: ".components-item",
                    sort: false
                  },
                  on: { end: _vm.onEnd }
                },
                _vm._l(_vm.componentList, function(element, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "components-item" },
                    [
                      _c("div", { staticClass: "components-body" }, [
                        _vm._v(" " + _vm._s(element.name) + " ")
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "center-board" }, [
      _c(
        "div",
        { staticClass: "action-bar" },
        [
          _c(
            "el-button",
            {
              staticClass: "copy-btn-main",
              attrs: { icon: "el-icon-success", type: "text" },
              on: { click: _vm.preview }
            },
            [_vm._v(" 预览 ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "delete-btn",
              attrs: { icon: "el-icon-delete", type: "text" }
            },
            [_vm._v(" 清空 ")]
          )
        ],
        1
      ),
      _c("div", { ref: "ipad", attrs: { id: "ipad" } }, [
        _c("div", { staticClass: "outeripad portrait" }, [
          _c("div", { staticClass: "ipadbody" }, [
            _c(
              "div",
              { staticClass: "ipadscreen" },
              [
                _c(
                  "el-scrollbar",
                  { staticClass: "center-scrollbar" },
                  [
                    _c(
                      "el-row",
                      { staticClass: "center-board-row" },
                      [
                        _c(
                          "el-form",
                          [
                            _c(
                              "draggable",
                              {
                                staticClass: "drawing-board",
                                attrs: {
                                  list: _vm.widgetList,
                                  animation: 200,
                                  group: "componentsGroup"
                                },
                                on: { end: _vm.onMianDragEnd }
                              },
                              _vm._l(_vm.widgetList, function(element, index) {
                                return _c(
                                  "el-col",
                                  {
                                    key: index,
                                    staticClass: "drawing-item",
                                    class: {
                                      "active-from-item":
                                        _vm.activeIndex === index
                                    },
                                    attrs: { span: element.span },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.selectItem(element, index)
                                      }
                                    }
                                  },
                                  [
                                    _c("render", { attrs: { item: element } }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "drawing-item-delete",
                                        staticStyle: {
                                          visibility: "visibility"
                                        },
                                        attrs: { title: "删除" },
                                        on: {
                                          click: function($event) {
                                            return _vm.delItem(element)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-close"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.widgetList.length,
                                    expression: "!widgetList.length"
                                  }
                                ],
                                staticClass: "empty-info"
                              },
                              [_vm._v(" 从左侧拖入或点选组件进行表单设计 ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "ipadcamera" })
          ])
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "right-board" },
      [
        _c(
          "el-tabs",
          {
            staticClass: "center-tabs",
            model: {
              value: _vm.currentTab,
              callback: function($$v) {
                _vm.currentTab = $$v
              },
              expression: "currentTab"
            }
          },
          [
            _c("el-tab-pane", { attrs: { label: "组件属性", name: "field" } }),
            _c("el-tab-pane", { attrs: { label: "表单属性", name: "form" } })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "field-box" },
          [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentTab === "field",
                        expression: "currentTab === 'field'"
                      }
                    ],
                    attrs: { size: "small", "label-width": "90px" }
                  },
                  [_vm._v(" " + _vm._s(_vm.test) + " ")]
                )
              ],
              1
            ),
            _c("el-form", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab === "form",
                  expression: "currentTab === 'form'"
                }
              ],
              attrs: { size: "small", "label-width": "90px" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }